import { BlacklistFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { ClientSchemaBlacklist } from "src/types/clientSchema";

import { mapToProperty } from "./property.mappers";

export const mapToClientSchemaBlacklist = (
  blacklist: BlacklistFragmentFragment
): ClientSchemaBlacklist => {
  return {
    name: blacklist.name,
    code: blacklist.code,
    properties: blacklist.properties.map(mapToProperty),
    sourceProperties: blacklist.identifier.sourceProperties.map(mapToProperty),
  };
};
